// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__16730","info":"Note_info__14f6-","note":"Note_note__Ie8Ne","actions":"Note_actions__3v4w3"};